
import http from '@/api/http';

export default class BaseRepository<T extends {}, RequestParams extends {} = {}, ListResponse = T[]> {

   constructor(source: string, id: keyof T) {
      Object.defineProperty(this, '_resource', {
         get: () => source,
      });

      Object.defineProperty(this, '_idField', {
         get: () => id,
      });
   }

   get _resource(): string {
      throw new Error('Unsupported operation exception');
   }

   get _idField(): keyof T {
      throw new Error('Unsupported operation exception');
   }

   public load(params: Nullable<RequestParams>): Promise<ListResponse> {
      return this._get(this._resource, params || {});
   }

   public get(id: keyof T, params: {} = {}): Promise<T> {
      return this._get(`${this._resource}/${id}`, params);
   }

   protected _get<P extends {}, R>(path: string, p: P): Promise<R> {
      const params = { ...p };
      return http.get(path, { params }) as any;
   }

   protected _post<R>(path: string, body: any): Promise<R> {
      return http.post(path, body) as any;
   }

   protected _put<R>(path: string, body: any): Promise<R> {
      return http.put(path, body) as any;
   }
}
